// Currently Segment is bootstraped through the backend:
// https://github.com/23/23/blob/master/packages/um/www/resources/integrations/segment/site.js

type Prerequisite = {
  product?:
    | 'Personal'
    | 'WebinarManagement'
    | 'VMP'
    | 'Spots'
    | 'WebinarSpots'
    | 'WebinarRoom'
}
type Properties = Prerequisite & Record<string, string | number | object>

declare global {
  interface Window {
    // Typed functions from documentations:
    // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript
    analytics?: {
      page: (name: string, properties: Properties) => void
      track: (event: string, properties: Properties) => void
    }
  }
}

export const page = (name: string, properties: Properties) =>
  window.analytics?.page(name, properties)

export const track = (event: string, properties: Properties) =>
  window.analytics?.track(event, properties)

export default { page, track }
